import { getSurfaceClassName } from './cardSurface';
import { normalizePatternId } from './cardPatterns';
import { getCardBaseBackgroundStyle } from './cardPatternStyle';

export function getOpenCardFaceClasses({ side = 'front' }) {
  return ['open-card-face', `open-card-face--${side}`].join(' ');
}

export function getOpenCardFaceBgClasses({ cardStyle, backgroundPattern }) {
  const pattern = normalizePatternId(backgroundPattern);
  return [
    'open-card-face-bg',
    getSurfaceClassName(cardStyle),
    `open-card-face-bg--pattern-${pattern}`,
  ].join(' ');
}

export function getOpenCardFaceStyle(opts) {
  return getCardBaseBackgroundStyle({
    mainColor: opts.mainColor,
    backgroundPattern: opts.backgroundPattern,
    gradientColor: opts.gradientColor,
    gradientAngle: opts.gradientAngle,
  });
}
